/** Game settings stored in localStorage. */

export interface GameSettings {
  playerName:    string
  volume:        number   // 0-100
  ghostPiece:    boolean
  defaultSpeed:  number   // 0=slow 1=normal 2=fast 3=turbo (for practice)
  touchControls: 'auto' | 'on' | 'off'
}

export const DEFAULT_SETTINGS: GameSettings = {
  playerName:    '',
  volume:        80,
  ghostPiece:    true,
  defaultSpeed:  1,
  touchControls: 'auto',
}

const KEY = 'beanstorm_settings'

export function loadSettings(): GameSettings {
  try {
    const raw = localStorage.getItem(KEY)
    if (raw) return { ...DEFAULT_SETTINGS, ...JSON.parse(raw) }
  } catch { /* ignore */ }
  return { ...DEFAULT_SETTINGS }
}

export function saveSettings(s: GameSettings): void {
  localStorage.setItem(KEY, JSON.stringify(s))
}
